// extracted by mini-css-extract-plugin
export default {"fontFamily":"FontFamily_fontFamily__NFY9-","box":"FontFamily_box__TBAks","active":"FontFamily_active__VROVj"};